import { default as ObjectID } from 'bson-objectid';
import moment from 'moment';
import { Dispatch } from 'redux';
import { IMoveEvent, MoveEvent } from 'shared/api/api';
import { AsyncOperationBuilder2 } from 'shared/helpers/redux-helpers';
import { localized } from 'shared/state/i18n/i18n';
import { StoreContainer } from 'shared/state/store-container';
import * as Action from './actions';
import { Monitoring } from 'shared/helpers/monitoring-service';


export function SaveMoveEvent(moveEvent: IMoveEvent, maxTries = 3, showAlert: (exceptionMessage: string) => void = () => { }) {
	const state = StoreContainer.getState();
	const prevEntity = state.moveEvents.entities.find(move => move.stemAnimalId === moveEvent.stemAnimalId);
	let isOverwritingSameDate = false;
	// If date is the same, update instead of create
	if (
		prevEntity &&
		prevEntity.moveDate &&
		moveEvent.moveDate &&
		prevEntity.moveDate.withoutTime().getTime() === moveEvent.moveDate.withoutTime().getTime()
	) {
		isOverwritingSameDate = true;
		moveEvent.moveDate = moment(prevEntity.moveDate).add(1, 'm').toDate();
	}

	if (!moveEvent.id) {
		if (!moveEvent.createdOn) {
			moveEvent.createdOn = new Date();
		}
		moveEvent.id = new ObjectID().toHexString();
	}
	// CIVAGAARD Logging
	Monitoring.logTraceCiva(moveEvent.siteId, `Saving Move Event - Move Date: ${moveEvent.moveDate}, To PenId ${moveEvent.penId}`, { StemAnimalId: moveEvent.stemAnimalId, SiteId: moveEvent.siteId, MoveEventId: moveEvent.id, SkioldFunction: "SaveMoveEvent" });

	return AsyncOperationBuilder2(
		Action.saveMoveEvent,
		client => client.moveEvent_Upsert(MoveEvent.fromJS(moveEvent), isOverwritingSameDate),
		MoveEvent.fromJS(moveEvent),
		prevEntity,
		undefined,
		undefined,
		maxTries,
		(errorCode: number, message: string) => {
			if (errorCode === 500) {
				showAlert(localized(message));
			}

		}
	);
}
export function GetSyncData() {
	const state = StoreContainer.getState();
	const siteId = state.profile.active!.siteId!;
	const lastSyncDate = state.moveEvents.lastSyncDate;

	if (state.moveEvents.syncInProgress) {
		return (dispatch: Dispatch<any>) => {
			return Promise.resolve();
		};
	}
	return AsyncOperationBuilder2(Action.getSyncData, client => client.moveEvent_Sync(siteId, lastSyncDate), {
		siteId,
		lastSyncDate,
	});
}

export function SaveSyncData() {
	const state = StoreContainer.getState();
	const updates = state.moveEvents.updates;
	let promises = new Array<Promise<void>>();
	return (dispatch: Dispatch<any>) => {
		if (state.moveEvents.saveSyncInProgress) {
			return Promise.resolve();
		}
		updates.forEach(update => {
			promises.push(SaveMoveEvent(update)(dispatch));
		});

		return Promise.all(promises);
	};
}

export function GetDeparturedMoveEvents() {
	const state = StoreContainer.getState();
	const siteId = state.profile.active!.siteId!;

	return AsyncOperationBuilder2(
		Action.getDeparturedMoveEvents,
		client => client.moveEvent_GetDeparturedMoveEvents(siteId),
		{ siteId },
	);
}

export function RemoveMoveEvent(id: string) {
	return (dispatch: Dispatch<any>) => {
		dispatch(Action.removeMoveEvent.started(id));
	};
}

export function GetMoveEventsByDateDictionary(stemAnimalIds: { [stemAnimalId: string]: Date }) {
	return AsyncOperationBuilder2(
		Action.getMoveEventsByDateDictionary,
		client => client.moveEvent_GetMoveEventsByDateDictionary(stemAnimalIds),
		stemAnimalIds,
	);
}

export function UpsertManyMoveEvents(moveEvents: MoveEvent[]) {
		const state = StoreContainer.getState();
	const prevEntities = state.moveEvents.entities.filter(move => moveEvents.some(event => event.stemAnimalId === move.stemAnimalId));
	return AsyncOperationBuilder2(
		Action.upsertManyMoveEvents,
		client => client.moveEvent_UpsertManyMoveEvents(moveEvents),
		moveEvents,
		prevEntities,
	);
}